import { SourceRead } from '../../api/apiTypes';
import { useSourceDetail } from '../../api/hooks/useSourceDetail';

type Props = {
  sources: SourceRead[];
  reportId: string;
  componentId: string;
  elementId: string;
};

const SourcesAccordion = ({ sources, reportId, componentId, elementId }: Props) => {
  const { cache, loading, error, fetchDetail } = useSourceDetail(reportId, componentId, elementId);

  const handleToggle = (e: React.SyntheticEvent<HTMLDetailsElement>, sourceId: string) => {
    if (e.currentTarget.open) {
      fetchDetail(sourceId);
    }
  };

  return (
    <div className="card-bg p-8 mt-8 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold text-textPrimary mb-6 font-heading">Fonti</h2>
      {sources && sources.length > 0 ? (
        sources.map((fonte, index) => (
          <details
            key={fonte.id}
            className="mb-2 border border-borderDivider rounded-md"
            onToggle={(e) => handleToggle(e, fonte.id)}
          >
            <summary className="cursor-pointer bg-accordionHeader px-4 py-3 text-textPrimary font-semibold font-heading rounded-md">
              {fonte.name || `Fonte ${index + 1}`}
            </summary>
            <div className="px-4 py-3 text-textSecondary font-paragraph whitespace-pre-line">
              {loading[fonte.id] ? (
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 border-2 border-gray-300 border-t-textPrimary rounded-full animate-spin" />
                  <span>Caricamento...</span>
                </div>
              ) : error[fonte.id] ? (
                <p className="text-red-500">{error[fonte.id]}</p>
              ) : cache[fonte.id] ? (
                <p>{cache[fonte.id].content}</p>
              ) : null}
            </div>
          </details>
        ))
      ) : (
        <p className="text-textSecondary font-paragraph">Nessuna fonte disponibile.</p>
      )}
    </div>
  );
};

export default SourcesAccordion;
